import dayjs from 'dayjs';
import { getFromLocalStorage } from 'utils/helpers';
import DataSearchList from './List/List';

// GLOBAL VARIABLES ************************************************************
// *****************************************************************************

const MODULE_ID = 'applekkusDataSearch';
const MODULE_API = '/v1/data-search';

// MODULE PARAMETERS ***********************************************************
// *****************************************************************************

const DATA_SEARCH_MODULE = {
  id: MODULE_ID,
  noBlockScreenWithAppNotConfigured: false,
  api: MODULE_API,
  urlCustomForm: null,
  defaultUrlQueryString: null,

  components: {
    // list
    dashboard: null,
    list: props => <DataSearchList {...props} />,
    grid: null,
    kanban: null,
    filter: null,

    // form
    form: null,
    formHeaderTitle: null,
    formHeaderSubtitle: null,
    formHeaderColumn1: null,
    formHeaderColumn2: null,
    formHeaderColumn3: null,
    formHeaderTags: null,
    formHeaderCustomIcons: null,

    // module Parameters
    parameters: null,

    // data preview
    dataImport: null,
    previewHeader: null,
    previewBody: null,
    previewActions: null,
  },

  methods: {
    decorateDocument,
    // canEditDocument
    // decorateParameters,
  },

  initialRequest: {
    folder: 'documents',

    folderOptions: ['documents', 'recycle', 'filed'],

    filter: {},

    filterOptions: {},

    pagination: {
      pageNumber: 1, // current page
      pageSize: getFromLocalStorage('pageSize'),
    },

    paginationOptions: {
      pageSize: [10, 20, 50, 100],
    },

    sorter: {
      '_metadata.audit.updatedAt': -1,
    },

    sorterOptions: ['name', '_metadata.audit.updatedAt', 'destiny', 'status'],

    search: {},

    textSearch: {},
  },

  listState: {
    override: true,
    hideBreadcrumb: false,

    showParameters: false,
    showDataImport: false,

    initTab: 'consultation',
    viewMode: ['list'], // 'list', 'kanban', 'grid' or 'dashboard'
    showNumberOfLine: false, // show number of line in table list
    showCheckBoxes: false, // show check boxes on table list for multiple selection
    hasFilter: true, // show the filter (folders and customs) drawer button
    hasAccessControl: true, // show the control access modal for this module
    isTableChanged: false, // detect if the table was changed, check if the currentQs is different of initialQs (includes column sorter, search and pagination)
    isFilterChanged: false, // detect if the filters was changed
  },

  documentState: {
    showParameters: false,

    disableLockForEdit: false,
    initTab: null,
    fieldName: 'name',
    newDocumentTitle: 'new_search',
    autoFill: false,
    actions: [
      'new',
      'edit',
      'reload',
      'divider',
      'duplicate',
      'file',
      'remove',
      'permanently_remove',
    ],
    refreshParametersOnSave: true,
    indexes: [],

    refreshDataOfDocument: 0,
    mockDocument: {},
  },
};

// EXPORT ********************************************************************
// ***************************************************************************

export default DATA_SEARCH_MODULE;

// INTERNAL FUNCTIONS ========================================================
// ===========================================================================

function decorateDocument(doc) {
  // departure and arrival dates decoration
  if (!doc?.departure || !doc?.arrival) return doc;
  doc.__travelPeriod = [dayjs(doc.departure), dayjs(doc.arrival)];
  doc.days = dayjs(doc.arrival).diff(doc.departure, 'days') + 1;

  // return
  return doc;
}
